module.exports = __webpack_public_path__ + "img/1500f.59b2715c.png";